import {IOption} from "../../../interface";
import './_v-option.scss';

export type VOptionProps = {
    title: string
    options: IOption[];
    value: string;
    onChange: (value: string) => void;
}

export default function VOption({title, options, value, onChange}: VOptionProps) {
    return (<div className='v-option-wrapper'>
        <h5 className='v-option-title'>
            {title}
        </h5>
        <div className='v-options'>
            {
                options.map((item) => (
                    <div key={item.value}
                         className={'v-option' + (value === item.value ? ' active' : '')}
                         onClick={() => onChange(item.value)}
                    >
                        {item.name}
                    </div>
                ))
            }
        </div>
    </div>);
}
